import React from 'react';

interface BetStatusLabelProps {
  status: string;
}

const BetStatusLabel: React.FC<BetStatusLabelProps> = ({ status }) => {
  if (!status) return null;

  return (
    <div className="bet-suspend absolute top-0 h-full left-[26px] width-[calc(100%-26px)] right-0 bg-gray-50 opacity-80 text-sm flex items-center justify-center font-bold rounded-md z-20">
      <span className="bg-white p-1">{status}</span>
    </div>
  );
};

export default BetStatusLabel;
